/**
 * THE SUB-PART TEST-ID CONVENTION for composite DS components.
 *
 * A component takes ONE root `testID`. Every part an E2E flow must be able to
 * reach on its own (a dialog's close button, a stepper's increment, one option
 * of a segmented control) gets `<testID>-<part>`, derived here — so a call site
 * names the component once and the parts come for free, the same string on
 * both platforms: RN `testID` (iOS `accessibilityIdentifier`, Android
 * resource-id — what an agent-device `id="…"` selector matches) and web
 * `data-testid` (Playwright `getByTestId`).
 *
 * Parts are short kebab-case nouns (`title`, `close`, `option-<value>`,
 * `page-3`); each component's types file lists the parts it emits. No root id →
 * no part ids (`undefined`), so an untagged component renders no test hooks.
 *
 * An explicit per-part `testID` a caller passes (an action's or option's own)
 * always wins over the derived one: `explicit ?? subTestID(testID, part)`.
 *
 * Native caveat: a part id is only REACHABLE when no ancestor is an
 * accessibility element (`accessible`, which every RN Pressable defaults to) —
 * a merged subtree is one node to iOS/Android automation.
 */
export function subTestID(
  testID: string | undefined,
  part: string | number,
): string | undefined {
  if (!testID) return undefined;
  return `${testID}-${part}`;
}
